import mutations from './mutations'
import actions from './actions'

const state = {
  all_credentials: [],
  credentials: [],
  credential: [],
  deleted_credentials: []
}

export default {
  state, mutations, actions
}